module.exports = __webpack_public_path__ + "videos/color-drop_cn.27d7fac.mp4";